import { Site } from '@envato/foundation-types'

const data: any = {
  [Site.themeforest]: [
    'food',
    'travel',
    'real estate',
    'portfolio',
    'landing page',
    'hotel',
    'blog',
    'education',
    'newspaper',
    'photography',
    'news',
    'dashboard',
    'ecommerce',
    'admin',
    'affiliate theme',
    'fashion',
    'electronics store',
    'jewelry',
    'furniture',
    'sport',
    'industry',
    'brochure',
    'building',
    'gym',
    'fitness',
    'spa',
    'health',
    'yoga',
    'dentist',
    'hair'
  ]
}

export default data
